const state = {
  list: [],
  isLoading: false,
  isUploading: false,
  hasEmpty: false,
  filter: {},
  activeListFF: [],
  activeListContainer: [],
  activeListCha: [],
  activeListPort: [],
  header: [],
  all: [],
  isShowLoading: false,
  excludeList: [],
  currentBdr: {},
};

export default state;
